import React, { useCallback } from 'react';
import ContentControl from '../ContentControl';
import classNames from 'classnames';

type Props = {
  plan: number;
  /** @default 'block' */
  size?: 'inline' | 'block';
};

function Sponsor({ plan, size = 'block' }: Props) {

  const sponsor0 = {
    sponsorLink: '',
    sponsorText: '이 메일은 스티비로 만들었습니다',
    sponsorIconUrl: 'https://stibee.com/assets/images/editor/sponsor_stibee_text_202106.png?v=20200312',
    sponsorIconWidth: 98,
  }

  const sponsor1 = {
    sponsorLink: '',
    sponsorText: '좋은 뉴스레터를 만들고 전하는 일,<br>스티비가 함께 합니다',
    sponsorIconUrl: 'https://stibee.com/assets/images/editor/sponsor_stibee_icon.png',
    sponsorIconWidth: 24,
  }

  const isSponsorPlan = plan === 1001 || plan === 1002;
  const sponsorText = isSponsorPlan ? sponsor1 : sponsor0;
  const Wrapper = useCallback(({ children }) => {
    if (isSponsorPlan) return children;
    return <ContentControl handleConfig={[{ handleName: 'upgrade', onClick: openUpgradeGuideModal }]}>{children}</ContentControl>;
  }, []);

  const openUpgradeGuideModal = () => {
    window.parent.postMessage({ msg: 'openUpgradeGuideModal', guideType: 'sponsorBanner' }, '*');
  }

  return (
    <div className={classNames('sponsor-container', size)}>
      <Wrapper>
        <div className="sponsor-box" >
            <img 
              src={sponsorText.sponsorIconUrl} 
              alt="stibee"
              style={{width:`${sponsorText.sponsorIconWidth}px`, height:'auto', verticalAlign: 'text-top',border:0}} width="{{{sponsorIconWidth}}}" />
            <p 
              style={{fontSize: '12px', color:'#333333', fontWeight: 'normal', verticalAlign: 'text-top', lineHeight: '1.7', margin:'6px 0', padding:'0'}}
              dangerouslySetInnerHTML={ {__html:sponsorText.sponsorText } } 
            />
        </div>
      </Wrapper>
    </div>
  );
}

Sponsor.defaultProps = {
};

export default Sponsor;